import React, { useState } from "react";
import { Form, Button, Modal, Col, Row } from "antd";
import useStore from "../store";
import { observer } from "mobx-react";
import { vsmNotify } from "../config/messages/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";

const LogOutConfirmationModal = observer((props) => {
	const history = useHistory();
	const [form] = Form.useForm();
	const {
		AUTH: { doLogout, logOutValues },
	} = useStore();
	const [saving, setSaving] = useState();
	
	// Make function call to status existing record
	const handleSubmit = (data) => {
		setSaving(true);
		doLogout().then((data) => {
			vsmNotify.success({
				message: data.STATUS.NOTIFICATION,
			});
		});
		history.replace("/");
	};

	// reset form and close add form
	const close = () => {
		props.close();
		form.resetFields();
	};


	return logOutValues ? (
		<Modal
			centered
			className="deleteModal"
			title={`Log Out?`}
			open={props.visible}
			closeIcon={<FontAwesomeIcon icon={faTimes} />}
			onCancel={close}
			cancelButtonProps={{ style: { display: "none" } }}
			okButtonProps={{ style: { display: "none" } }}
			footer={[
				<Button
					key="2"
					htmlType="button"
					className="cancelBtn mr-35"
					onClick={close}
				>
					Cancel
				</Button>,
				<Button
					key="1"
					form="logOutForm"
					loading={saving}
					htmlType="submit"
					type="primary"
					danger
				>
					Confirm
				</Button>,
			]}
		>
			<Form form={form} id="logOutForm" onFinish={handleSubmit}>
				{
					<Row align="middle">
						<Col span={24} className="text-center">
							<h3>
								<span>
									<FontAwesomeIcon icon={faExclamationTriangle} />
								</span>Are you sure you want to logout <span>"{logOutValues.name}"</span>?
							</h3>
						</Col>
					</Row>
				}
			</Form>
		</Modal>
	) : null;
	// );
});

export default LogOutConfirmationModal;
